import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import {tablecostlistapi, api, Tablecostdelete} from '../../../apis/urls'
import Loader from '../../../common-components/loader'
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";

const TablecostList =()=> {

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);


    let navigate = useNavigate();

    const Listing = () => {
        
    let token = "Bearer "+localStorage.getItem('token');
    //console.log(token)

    const instance = axios.create({
        baseURL: tablecostlistapi,
        timeout: 1000000,
        headers: {'authorization': token}
      });

      instance.get('').then(res => {

        if(res.data.message === "Success"){            
            settablecostList(res.data.data.items);
            setCurrentpage(res.data.data.currentPage)
            setTotalPages(res.data.data.totalPages)
            setTotalItems(res.data.data.totalItems)
        }else{
            settablecostList(false)
        }
        setLoader(false)
    });
    }

    const [loader,setLoader] = useState(false);
    const [tablecostList, settablecostList] = useState([]);
    const [searchNum, setsearchNum] = useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);


    
    let counts = 0;
    if(tablecostList)
    {
        counts = tablecostList.length;
    }

    

    const DeleteTablcost= (id) => {
        let r = window.confirm("Are you sure you want to delete this Table cost?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: Tablecostdelete+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Listing();
                navigate("/tablecostlist")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            });
        }
    }

    const refreshList = () => {
        settablecostList(null);
    };


    let token = "Bearer "+localStorage.getItem('token');
    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get(`tablecostlist?search=${name}`);
    };

    // const onChangeSearchTitle = (e) => {
    //     const searchTitle = e.target.value;
    //     setSearchTitle(searchTitle);
    //     findByTitles(searchTitle)
    //       .then(response => {

    //         if(response.data.message=== "Success"){
    //             setdegreeList(response.data.data.items)
    //         }else{
    //             setdegreeList(false)
    //         }
            
    //       })
    //       .catch(e => {
    //         console.log(e);
    //       });
    // };

    // const findByTitlesss = option => {
        
    //     return instances.get(`degrees?status=${option}`);
    // };

    // const onChangeSearchTitles = (e) => {
    //     const searchTitle = e.target.value;
    //     findByTitlesss(searchTitle)
    //       .then(response => {

    //         if(response.data.message=== "Success"){
    //             setdegreeList(response.data.data.items)
    //         }else{
    //             setdegreeList(false)
    //         }
            
    //       })
    //       .catch(e => {
    //         console.log(e);
    //       });
    // };


        //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     const instance = axios.create({
         baseURL: tablecostlistapi+'?page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

        settablecostList(res.data.data.items)
     
    
     console.log('paginatansresss',res.data.data)
     
         setLoader(false);
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });




     // const newOffset = (event.selected * 10) % items.length;
     // console.log(
     // `User requested page number ${event.selected}, which is offset ${newOffset}`
     // );
     // setItemOffset(newOffset);
 };
 
    let sl =1;
    return(
        <div>
        <aside class="right-side areas">
			<div class="content-area dash-contentss">
                <div class="page-title-wrpr">
                <div class="page-title-left-column">
                    <i class="icon-library1"></i>
                    <h2 class="page-title"> Table Cost List</h2>
                </div>
                <div class="page-rightside-action-column">
                <div class="input-groups mt-3 mb-3 search-grp">
                    <div class="input-group-prepends">
                    <select class="form-controls custom-select" >
                        <option value="none" selected disabled hidden>STATUS</option>
                        <option value=" ">ALL</option>
                        <option>ACTIVE</option>
                        <option>INACTIVE</option>
                        <option>DELETE</option>
                        </select> 
                    </div>
                    <input type="text" 
                    class="form-controls search-bar"             
                   
                    placeholder="Search" />
                    <button  class="btn btn-search icon-search"></button>
                    </div>
                    <Link to="/add_tablecost" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Table Cost</span> </Link>
                </div>
            </div>
             
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item active" aria-current="page">Table Cost List</li>
              </ol>
            </nav>

            {emptyItem?
            <div class="number-of">
                Displaying 1-{counts} of {totalItems} results.
            </div>:null
            }



            <div class="faculty-list-wrpr list-wrpr">
            {tablecostList?(
            tablecostList?.map(tablecost =>
                <div class="list faculty">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">{sl++}</span>
                                <span class="desig">Sl.No</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="faculty-user">
                                <span class="desig">Table Count</span>
                                <span class="date-wrpr">{tablecost.table_num}</span>
                            </div>     
                        </div>
                        <div class="col-md-3">
                            <div class="update-date">
                                <span class="date-wrpr">${tablecost.cost}</span>
                                <span class="desig">Cost</span>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">{tablecost.status}</span>
                                <span class="desig">Status</span>
                            </div>
                        </div>
                        
                        <div class="col-md-2">
                            <div class="list-action-wrpr text-right roundicons-text">
                                <Link  to={"/edit_tablecost/"+tablecost.id} data-toggle="tooltip" title="Edit"  ><i class="edit icon-pencil3"></i><span>Update</span></Link>
                                <button onClick={() => { DeleteTablcost(tablecost.id) }} data-toggle="tooltip" title="Delete" style={{backgroundColor:'#fff'}} ><a><i  class="delete icon-close1"></i><span>Delete</span></a></button>
                            </div>
                        </div>

                    </div>

                    
                </div>
                )):null
                }
                {
                    !tablecostList?
                    (<div className="nodata">
                        <h2>Sorry! No Result Found</h2>
                    </div>):null
 
                }

                {tablecostList?
                    <div class="number-of footer-number">
					    Displaying 1-{counts} of {totalItems} results.
				    </div>:null
                }
                        
     
            </div>    
            { 
                loader?
                <div>
                    <div className="loader_container"><Loader/></div>
                </div>
                :
                null
            }
                {tablecostList?
                <div class="pagination-wrpr">
                    <ReactPaginate
                            className="pagination page"
                            pageClassName="page-item"
                            activeClassName="active"
                            nextLabel=">"
                            previousLabel="<"
                            previousClassName="page-link p-link"
                            nextClassName="page-link p-link"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={10}
                            pageCount={totalPages}
                            renderOnZeroPageCount={1}
                        />
                </div>:null
                }


        </div>
        </aside>
    </div>
    );
}

export default TablecostList;


